import { TableCell, TableRow, Tooltip } from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";
import { user_roles } from "shared/utils/constants";

const PartnersRequests = () => {
  const tasksList = [
    {
      role: 5,
    },
    {
      role: 5,
    },
    {
      role: 6,
    },
    {
      role: 5,
    },
    {
      role: 5,
    },
    {
      role: 6,
    },
  ];

  return (
    <>
      {tasksList?.map((item: any, index: any, arr: any) => {
        return (
          <TableRow
          // className={classNames(index + 1 === arr.length && styles.lastCells)}
          >
            <TableCell>
              <div className={styles.nameCell}>
                <img
                  src={Images.UserPlaceholderImage}
                  alt="profile_picture"
                  className={styles.profilepic}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Jane Doe</label>
                  <label className={styles.emailLabel}>janedoe@gmail.com</label>
                </div>
              </div>
            </TableCell>
            <TableCell>03103212312</TableCell>
            <TableCell>
              {item?.role === user_roles.publisher
                ? "Publisher"
                : item?.role === user_roles.author
                ? "Author"
                : ""}
            </TableCell>
            <TableCell className={classNames(styles.statusCell)}>
              <label className={styles.pending}>Open</label>
            </TableCell>
            <TableCell>
              <div className={styles.actionContainer}>
                <Tooltip arrow title="View MOUs">
                  <div>
                    <Icons.EyeIcon className={styles.icons} />
                  </div>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default PartnersRequests;
